import styled from 'styled-components'

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex: 1;

  span {
    text-align: center;
  }
`
